import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BlogList, BlogDetail, BlogSearchCriteria } from '../../../_models/blogs/blog.model';
import { ApiResponse } from '../../../_models/api-response.model';
import { Page } from '../../../_models/page.model';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PublicBlogService {
  private apiUrl = `${environment.apiUrl}/blogs`;

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  getPublicBlogs(
    criteria: BlogSearchCriteria = {},
    page: number = 0, 
    size: number = 10, 
    sort: string = 'createdAt', 
    direction: string = 'DESC'
  ): Observable<ApiResponse<Page<BlogList>>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort)
      .set('direction', direction);
    if (criteria.search) {
      params = params.set('search', criteria.search);
    }
    return this.http.get<ApiResponse<Page<BlogList>>>(this.apiUrl, { params });
  }

  getPublicBlogDetail(slug: string): Observable<ApiResponse<BlogDetail>> {
    return this.http.get<ApiResponse<BlogDetail>>(`${this.apiUrl}/${slug}`);
  }
}